import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    content: {
        height: '100dvh',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            marginLeft: 104,
            marginRight: 8,
        },
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: 'white',
        borderRadius: '.5em',
        boxSizing: 'border-box',
    },
}));
